import React, {useEffect, useMemo, useState} from 'react';
import {message} from 'antd';
import TableComponent from '../../../components/molecules/Table/component';
import {campaignPromotersTableColumns} from '../../../components/molecules/Table/columns';
import campaignService from '../../../services/campaignService';
import {createUserTableChangeHandler, useIsMobile} from '../../../utils/helpers';
import {useNavigate, useParams} from 'react-router-dom';
import {mobileRenderers} from "../../../components/molecules/Table/tableMobileRenderers";

const CampaignPromotersPage: React.FC = () => {
    const navigate = useNavigate();
    const {id} = useParams<{ id: string }>();
    const [promoterList, setPromoterList] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const isMobile = useIsMobile();

    const [filters, setFilters] = useState({
        userType: '',
        search: '',
        sortBy: '',
        sortDirection: 'desc' as 'asc' | 'desc',
    });

    const onTableChange = useMemo(
        () => createUserTableChangeHandler(filters, setFilters),
        [filters]
    );

    useEffect(() => {
        const fetchCampaignPromoters = async () => {
            setLoading(true);
            try {
                const data = await campaignService.getCampaignPromoters(
                    id as string,
                    filters
                );
                setPromoterList(Array.isArray(data) ? data : []);
            } catch (error: any) {
                console.error('Error fetching campaign promoters:', error);
                message.error(error.message || 'Error fetching campaign promoters');
            } finally {
                setLoading(false);
            }
        };

        fetchCampaignPromoters();
    }, [filters, id]);

    const handleRowClick = (record: any) => {
        navigate(`/promoters/${record.promoterId}/${record.campaignLinkId}`);
    };

    return (
        <div style={{position: 'relative', padding: 20}}>
            <TableComponent columns={campaignPromotersTableColumns} title={"Campaign promoters"}
                            data={promoterList || []} onRowClick={handleRowClick} loading={loading}
                            onChange={onTableChange} isMobile={isMobile} mobileVariant="campaignPromoters"
                            mobileRenderers={mobileRenderers} rowKey={(row) => row._id}
            />
        </div>
    );
};

export default CampaignPromotersPage;